import request from '@/utils/request'
import { apiUrl } from './config'

type dataType = any

export default {
    // 龙头猎手详情 (iscode=2)
    getDetail(data: dataType): Promise<{ response?: Response }> {
        return request({
            url: apiUrl + `/rjhy-quota-index/api/1/dragon/hunter/detail`,
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                token: data.token
            },
            sign: true
        })
    },

    // 龙头信号详情 (iscode=1)
    getSignalDetail(data: dataType): Promise<{ response?: Response }> {
        return request({
            url: apiUrl + `/rjhy-quota-index/api/1/dragonsignal/detail`,
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                token: data.token
            },
            sign: true
        })
    },

    // 获取龙头信号指标，用于取 tradingDay
    getMultipleIndex(data: dataType): Promise<{ response?: Response }> {
        return request({
            url: apiUrl + `/rjhy-quota-index/api/1/multiple/index`,
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                token: data.token
            },
            sign: true
        })
    }
}
